import { FolderMinus, FolderPlus } from 'lucide-react';

/**
 * The connection row menus' project entry (cards 5.2–5.4), in the
 * `{ id, label, Icon, onSelect }` shape the FTP / Terminal row menus use:
 * "Add to <project>" or "Remove from <project>" for the ACTIVE project, from
 * `useConnectionProjectGroups().membershipAction(row)`. None under All
 * projects / No project, or for a "this session only" row.
 */
export function projectMenuItems(action, t) {
  if (!action) return [];
  const add = action.kind === 'add';
  return [
    {
      id: add ? 'project-add' : 'project-remove',
      label: add ? t('projectScope.addTo', { name: action.project.name }) : t('projectScope.removeFrom', { name: action.project.name }),
      Icon: add ? FolderPlus : FolderMinus,
      onSelect: action.run,
    },
  ];
}
